import { render, staticRenderFns } from "./feature-promo-items.vue?vue&type=template&id=78bf93e9&scoped=true"
import script from "./feature-promo-items.vue?vue&type=script&lang=js"
export * from "./feature-promo-items.vue?vue&type=script&lang=js"
import style0 from "./feature-promo-items.vue?vue&type=style&index=0&id=78bf93e9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bf93e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1053244670/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78bf93e9')) {
      api.createRecord('78bf93e9', component.options)
    } else {
      api.reload('78bf93e9', component.options)
    }
    module.hot.accept("./feature-promo-items.vue?vue&type=template&id=78bf93e9&scoped=true", function () {
      api.rerender('78bf93e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/features/feature-promo-items.vue"
export default component.exports